import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/context.authentication";
import {
  getSession,
  refetchSessionToken,
  validSession,
} from "../fetch/const.routes";
import { UserRole, UserSession } from "../types/User.ts";

type useAuthTokenType =
  | { status: "loading" }
  | { status: "error"; error: string }
  | {
      status: "ok";
      isRole: (reqRole: UserRole) => boolean;
      isVerified: boolean;
      authId: string;
      logout: () => void;
      refetchSessionToken: () => Promise<void>;
    };

export function useAuthToken(): useAuthTokenType {
  const { auth, logout } = useContext(AuthContext);
  const [session, setSession] = useState<UserSession>(getSession());
  const [loading, setLoading] = useState(auth.ok && !validSession(session));

  useEffect(() => {
    if (!auth.ok || validSession(session)) return;
    setLoading(true);
    refetchSessionToken(auth, session).then((res) => {
      setSession(res);
      setLoading(false);
    });
  }, [auth]);

  const manuelRefresh = async () => {
    setLoading(true);
    const res = await refetchSessionToken(auth, session, true);
    setSession(res);
    setLoading(false);
    return;
  };
  if (loading) return { status: "loading" };
  if (!session.ok || !auth.ok)
    return { status: "error", error: "Session invalide" };
  const isRole = (reqRole: UserRole) => reqRole >= session.role;
  const isVerified = session.verified;
  const authId = session.sub;

  return {
    status: "ok",
    isRole: isRole,
    isVerified: isVerified,
    authId: authId,
    logout: logout,
    refetchSessionToken: manuelRefresh,
  };
}
